import React from 'react';

import Button from 'components/Button';
import CoachingHomeFreeTrialCard from 'coaching/components/CoachingHomeView/CoachingHomeFreeTrialCard';
import Columns2 from 'components/Columns2';
import LinkConstants from 'constants/LinkConstants';
import { coachingHomeEventPrefix } from 'coaching/components/CoachingHomeView/CoachingHomeView';
// @ts-ignore
import userAgent from 'lib/currentUserAgent';
import {
  ParticipantMetadata,
  CoachingSessionTools,
} from 'coaching/components/CoachingHomeView/CoachingSessionsBySubjectContainer';

export type Props = {
  participantMetadata: ParticipantMetadata;
  userUuid: string;
  hasStudentInvitation: boolean;
  sessionTools?: CoachingSessionTools;
};

export default function CoachingHomeFreeTrial(props: Props) {
  const { participantMetadata, userUuid, hasStudentInvitation, sessionTools } = props;
  const isParentWithStudent = userIsParentWithStudent(
    participantMetadata,
    userUuid,
    hasStudentInvitation
  );
  const messageCoachTitleCopy = isParentWithStudent
    ? 'Help your child send an example homework assignment.'
    : 'Send an example homework assignment';
  const messageCoachBodyCopy = `${
    isParentWithStudent ? '' : 'as a Remind message.'
  } You can share a file, a screenshot, or even a photo of printed materials.`;
  const joinSessionBodyCopy = `${
    isParentWithStudent ? 'Help your child log in to their' : 'Log into your'
  } account at remind.com from a computer and have a large touch screen for the whiteboard.`;
  const shareHomeworkImage = userAgent.isDesktop()
    ? require('assets/images/coaching/home/share_homework_vert.png')
    : require('assets/images/coaching/home/share_homework_horiz.png');
  const prepareForSessionImage = userAgent.isDesktop()
    ? require('assets/images/coaching/home/prepare_for_session_vert.png')
    : require('assets/images/coaching/home/prepare_for_session_horiz.png');

  return (
    <>
      <Columns2
        className="CoachingSessionsBySubjectContainer-cardContainer"
        data-test="free-trial-cards"
        gutter="large">
        <CoachingHomeFreeTrialCard
          data-test="message-coach-free-trial-card"
          button={sessionTools && constructMessageCoachButton(sessionTools)}
          timeText="24 hours in advance"
          titleText={messageCoachTitleCopy}
          bodyText={messageCoachBodyCopy}
          image={shareHomeworkImage}
        />
        <CoachingHomeFreeTrialCard
          data-test="join-session-free-trial-card"
          button={
            <Button size="small" target="_blank" href={LinkConstants.COACHING_HELP_DEVICE_SETUP}>
              Set up devices
            </Button>
          }
          timeText="15 minutes in advance"
          titleText="Two devices is best:"
          bodyText={joinSessionBodyCopy}
          image={prepareForSessionImage}
        />
      </Columns2>
    </>
  );
}

function constructMessageCoachButton(sessionTools: CoachingSessionTools) {
  const { streamUuid } = sessionTools;
  const linkProps = userAgent.isDesktop()
    ? { to: `/coaching/messages/${streamUuid}` }
    : {
        href: `${LinkConstants.MOBILE_WEB_CHAT_LINK}/${streamUuid}?tutoring=true`,
        target: '_blank',
      };

  return (
    <Button {...linkProps} size="small" eventKey={`${coachingHomeEventPrefix}.message_coach.click`}>
      Message tutor
    </Button>
  );
}

function userIsParentWithStudent(
  participantMetadata: ParticipantMetadata,
  userUuid: string,
  hasStudentInvitation: boolean
) {
  const isStudent = participantMetadata.studentUuid === userUuid;
  const hasChild = participantMetadata.studentUuid || hasStudentInvitation;
  return !isStudent && hasChild;
}
